import aftersalesList from './list'
import aftersalesReplay from './replay'
import aftersalesReplayList from './replay/list'
import wechatlist from './wechatlist'
import alipaylist from './alipaylist'
import alipayreplay from './alipayreplay'
import alipayInfo from './alipayInfo'
import wechatreplay from './wechatreplay'
import wechatInfo from './wechatInfo'
import wechatInfoReplay from './wechatInfoReplay'
import equipmentManagement from './equipmentManagement'
import undividedAccount from './undividedAccount'
import closedownlist from './closedownlist'
import goods from '../platform/goods'
import addclosedownlist from './addclosedownlist'
import merchantRecord from "./merchant/index"
import afterSalesList from "./aftersaleslist/aftersaleslist"
import merchantBlack from "./merchantBlack/index"
import addBlack from "./merchantBlack/addBlack"
import merchantVideo from "./merchantVideo/index"
import notAccountMerchant from './notAccountMerchant'
import merchantAppeals from './merchantAppeals' //申诉列表
import receiverContract from './receiverContract/index' //诸葛分账-合同审核
import goodsReview from './goodsReview' //图册收款管理
import merchantAccredit from "./merchantAccredit" //信证签授权书审核
import merchantAuth from "./merchantAuth"; //认证风险商户

const aftersales = {
  path: '/aftersales',
  component: resolve => require(['@/pages/admin/aftersales'], resolve),
  redirect: '/aftersales/list',

  children: [
    aftersalesList,
    aftersalesReplay,
    aftersalesReplayList,
    wechatlist,
    alipaylist,
    alipayreplay,
    alipayInfo,
    wechatInfo,
    wechatInfoReplay,
    wechatreplay,
    equipmentManagement,
    undividedAccount,
    closedownlist,
	goods,
    addclosedownlist,
    merchantRecord,
    afterSalesList,
    merchantBlack,
    addBlack,
    merchantVideo,
    notAccountMerchant,
	merchantAppeals,
	receiverContract,
	goodsReview,
    merchantAccredit,
    merchantAuth
  ],
  meta: {
    requireAuth: true
  },
}

export default aftersales
